import ItemCard from "../../ListItem/ItemCard";
import ListScroll from "../../ListScroll/ListScroll";

import "./SpecialOffers.css";

function SpecialOffers(props) {
    let items = props.specialOffers;

    return (
        <div className='SpecialOffersComponent'>
            <div className='caption'>
                <a href='/search/?is_special_offer=true'>فروش ویژه</a>
                <a href='/search/?is_special_offer=true' className='all'>
                    (مشاهده همه)
                </a>
            </div>
            <div className='SpecialOffersContainer'>
                <ListScroll items={items} Component={ItemCard} key='id' />
            </div>
        </div>
    );
}

export default SpecialOffers;
